if (!customElements.get('gift-wrap-toggle')) {
  customElements.define(
    'gift-wrap-toggle',
    class GiftWrapToggle extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('.gift-wrap__checkbox');
        this.messageWrapper = this.querySelector('.gift-wrap__message');
        this.messageInput = this.messageWrapper ? this.messageWrapper.querySelector('textarea') : null;
        this.variantId = this.checkbox.dataset.variantId;

        this.checkbox.addEventListener('change', this.onToggle.bind(this));

        if (this.messageInput) {
          this.messageInput.addEventListener('input', debounce(this.onMessageInput.bind(this), ON_CHANGE_DEBOUNCE_TIMER));
        }
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'gift-wrap-toggle') return;
          this.syncState();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      setMessageVisible(visible) {
        if (this.messageWrapper) this.messageWrapper.hidden = !visible;
      }

      syncState() {
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const item = cart.items.find((item) => `${item.variant_id}` === `${this.variantId}`);
            this.checkbox.checked = Boolean(item);
            this.setMessageVisible(Boolean(item));
            if (item && this.messageInput) {
              this.messageInput.value = (item.properties && item.properties['Gift Message']) || '';
            }
          })
          .catch((e) => console.error(e));
      }

      onToggle() {
        const checked = this.checkbox.checked;
        const cartElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        const sections = cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [];

        this.checkbox.disabled = true;
        this.setMessageVisible(checked);

        const body = checked
          ? JSON.stringify({
              items: [{ id: this.variantId, quantity: 1 }],
              sections,
              sections_url: window.location.pathname,
            })
          : JSON.stringify({
              id: this.variantId,
              quantity: 0,
              sections,
              sections_url: window.location.pathname,
            });

        fetch(checked ? routes.cart_add_url : routes.cart_change_url, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.checkbox.checked = !checked;
              this.setMessageVisible(!checked);
              return;
            }

            if (!checked && this.messageInput) this.messageInput.value = '';

            if (cartElement) {
              cartElement.getSectionsToRender().forEach((section) => {
                const target =
                  document.getElementById(section.id).querySelector(section.selector) ||
                  document.getElementById(section.id);
                target.innerHTML = cartElement.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              });
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap-toggle', cartData: parsedState });
          })
          .catch((e) => {
            console.error(e);
            this.checkbox.checked = !checked;
            this.setMessageVisible(!checked);
          })
          .finally(() => {
            this.checkbox.disabled = false;
          });
      }

      onMessageInput() {
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const item = cart.items.find((item) => `${item.variant_id}` === `${this.variantId}`);
            if (!item) return;

            const body = JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: { 'Gift Message': this.messageInput.value },
            });

            return fetch(routes.cart_change_url, { ...fetchConfig(), ...{ body } });
          })
          .catch((e) => console.error(e));
      }
    }
  );
}
